
export default function WhyChooseProducts(){

return(

<section className="why-products">
    <div className="container">
        <h2>Why Choose Our Products?</h2>
        <p className="section-subtitle">
            We deliver high-quality paper and board solutions backed by
            reliable sourcing, competitive pricing and exceptional customer service.
        </p>
        <div className="why-grid">

            <div>
                <h4>Premium Quality</h4>
                <p>Every product meets strict quality standards.</p>
            </div>

            <div>
                <h4>Competitive Pricing</h4>
                <p>Affordable solutions without compromising quality.</p>
            </div>

            <div>
                <h4>Reliable Supply</h4>
                <p>Consistent stock and on-time delivery.</p>
            </div>

            <div>
                <h4>Global Sourcing</h4>
                <p>Trusted partners from around the world.</p>
            </div>

        </div>
    </div>

</section>

);

}
